import TagManager from 'react-gtm-module';

export function initializeGTM() {
  return TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID,
    auth: process.env.REACT_APP_GTM_AUTH,
    preview: process.env.REACT_APP_GTM_PREVIEW,
  });
}

export function googleTrackCompleteRegistration() {
  TagManager.dataLayer({
    dataLayer: {
      event: 'completeRegistration',
    },
  });
}

export function googleTrackViewCheckout() {
  TagManager.dataLayer({
    dataLayer: {
      event: 'viewCheckout',
    },
  });
}

export function googleTrackViewServiceDetail(serviceId) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'viewServiceDetail',
      serviceId,
    },
  });
}

export function googleTrackSubscribe() {
  TagManager.dataLayer({
    dataLayer: {
      event: 'subscribe',
    },
  });
}
